import { Injectable } from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from "@angular/common/http";
import {
  CategoryModel,
  CategoryTreeNode,
  CategoryTreeNodeDump
} from 'app/archivage/common/services/category/category.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {DaoGenericWithStorage} from '../../helper/helperDaoGeneric';
import {DirCmpEntite} from '../dircmp/dircmp.model';


@Injectable({
  providedIn: 'root'
})
export class CategoryService extends DaoGenericWithStorage<CategoryModel> {
  private url = `${environment.baseUrl}/api_archive/category/`;
  private _storageCat: BehaviorSubject<CategoryTreeNodeDump[]> = new BehaviorSubject([]) ;
  public storageCat$ = this._storageCat.asObservable();
  private _counter = 0;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  /**
   * src/app/common/core/services/gestion-universite/entite-tree-node/entite-tree-node.service.ts
   *     EntiteTreeNodeService.listDump
   *     Différence:
   *     - EntiteTreeNodeDump <> CategoryTreeNodeDump
   *     - this.url
   * @param entities : les entités étant sur des DUAs des catégories ramenées
   */
  listDump(entities: number[] = null): Observable<CategoryTreeNodeDump[]> {
    let params;
    if (entities) {
      params = {entities: entities};
    }
    return this.httpClient.get<CategoryTreeNodeDump[]>(`${this.url}extended_dump/`, {params});
  }

  /**
   * Catégories avec le count(duas) pour chacune
   * @param reload : force le rafraîchissement du cache
   * @param entities : les entités étant sur des DUAs des catégories ramenées
   */
  listDumpStored(reload= false, entities: number[] = null): Observable<CategoryTreeNodeDump[]> {
    return new Observable(observer => {
      if (reload) {
        this._counter = 0;
      }
      if (this._counter === 0) {
        this._counter++;
        this.listDump(entities).subscribe(_results => {
          this._storageCat.next(_results);
          observer.next(_results);
          observer.complete();
        });
      } else {
        observer.next(this._storageCat.value);
        observer.complete();
      }
    });
  }

  moveToTargetPos(dragNodeId: number, targetNodeId: number, pos: "left" | "right" | "last-child") {
    /*
    src/app/common/core/services/gestion-universite/entite-tree-node/entite-tree-node.service.ts
    EntiteTreeNodeService.moveToTargetPos
    Différence:
    - this.url
    */
    return this.httpClient.put<any>(`${this.url}extended_move/`, {src: dragNodeId, tgt: targetNodeId, pos: pos});
  }

  addToParent(category: CategoryTreeNode, parentId: number) {
    /*
    src/app/common/core/services/gestion-universite/entite/entite.service.ts
    EntiteService.addToParent
    Différence:
    - this.url
    */
    return this.httpClient.post<any>(`${this.url}extended_add/`, {category: category, parent_id: parentId});
  }

  /* TODO
  - Peut être faire extends DaoGeneric<CategoryTreeNode> ? pour delete, get
  - Enlever TreeNode des modèles ?
  */
  /*
  src/app/common/core/services/gestion-universite/entite/entite.service.ts
  EntiteService.delete / get / update
  Différence:
  - Entite a 2 services EntiteTreeNodeService & EntiteService <> Category un seul
  - Entite a 2 modéles, Entite(MP_Node) et EntiteTreeNode(Entite), à cause du manager dans Entite
    Category a un seul modele Category(MP_Node) -> CategoryTreeNode
  - this.url
  */
  delete(category: CategoryTreeNode) {
    return this.httpClient.delete<CategoryTreeNode>(`${this.url}${category.id}/`);
  }

  get(id: number) {
    return this.httpClient.get<CategoryTreeNode>(`${this.url}${id}/`);
  }

  update(category: CategoryTreeNode) {
    return this.httpClient.put<CategoryTreeNode>(`${this.url}${category.id}/`, category);
  }
  public sortBy(categories: CategoryModel[] = [], property = 'name') {
    categories.sort((x, y) => (x[property] < y[property] ? -1 : 1));
  }
}
